export type JoinCodeResult = {
  code: string;
  isFallback: boolean;
};

export function normalizeJoinCode(value: string): string {
  return value.trim().replace(/\s+/g, '').toUpperCase();
}

export function getGymJoinCode(gymId: string, joinCode?: string | null): JoinCodeResult {
  const trimmed = joinCode?.trim() ?? '';
  if (trimmed.length > 0) {
    return { code: trimmed, isFallback: false };
  }
  return { code: gymId.slice(0, 6).toUpperCase(), isFallback: true };
}

export function generateGymJoinUrl(code: string): string {
  return `https://douevenlift.com/gym/${code}`;
}
